import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=2530dafc"
import script from "@/scripts/components/column/balance.js?vue&type=script&lang=js&external"
export * from "@/scripts/components/column/balance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports